const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Whether the value is a UUID (versions 1–5, RFC 4122 variant), ignoring surrounding whitespace.
 * @param {?string} value
 * @returns {boolean}
 */
export const isValidUuid = (value) => UUID_REGEX.test((value || "").trim());
